import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { PmasApiClient, pmasApiRef } from './api';
import { rootRouteRef } from './routes';

export const pmasPlugin = createPlugin({
  id: 'pmas',
  apis: [
    createApiFactory({
      api: pmasApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new PmasApiClient({ discoveryApi, fetchApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const PmasPage = pmasPlugin.provide(
  createRoutableExtension({
    name: 'PmasPage',
    component: () => import('./App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
